<!-- 
	This is the dashboard layout, used in dashboard, tables, billing and profile pages.
 -->

<template>
  <div>
    <!-- Dashboard Layout -->
    <a-layout
      class="layout-dashboard"
      id="layout-dashboard"
      :class="[
        navbarFixed ? 'navbar-fixed' : '',
        !sidebarCollapsed ? 'has-sidebar' : '',
        themeDarkMode ? 'dark-mode' : '',
        layoutClass,
      ]"
    >
      <!-- Main Sidebar -->
      <DashboardSidebar
        :sidebarCollapsed="sidebarCollapsed"
        :sidebarColor="sidebarColor"
        :sidebarTheme="sidebarTheme"
        @toggleSidebar="toggleSidebar"
      ></DashboardSidebar>
      <!-- / Main Sidebar -->

      <!-- Layout Content -->
      <a-layout>
        <!-- Layout Header's Conditionally Fixed Wrapper -->
        <DashboardHeader
          :sidebarCollapsed="sidebarCollapsed"
          :navbarFixed="navbarFixed"
          @toggleSettingsDrawer="toggleSettingsDrawer"
          @toggleSidebar="toggleSidebar"
        ></DashboardHeader>
        <!-- / Layout Header's Conditionally Fixed Wrapper -->

        <!-- Page Content -->
        <a-layout-content>
          <router-view />
        </a-layout-content>
        <!-- / Page Content -->

        <!-- Layout Footer -->
        <DashboardFooter></DashboardFooter>
        <!-- / Layout Footer -->

        <!-- Floating Action Button For Toggling Settings Drawer -->
        <!-- แก้ -->
        <a-button class="fab" shape="circle" @click="showSettingsDrawer = true">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
              fill="#111827"
            />
          </svg>
        </a-button>
        <div class="mock_nav" v-if="$store.getters.getMock">
          <div class="status">
            <!-- <span class="ant-badge-status-dot ant-badge-status-success"></span> -->

            <span
              class="mb-0 ant-badge ant-badge-status ant-badge-not-a-wrapper"
              style="margin-top: 5px"
              >{{
              }}<span class="ant-badge-status-text mr-10"
                >โหมดทดลองเล่น</span
              ></span
            >
          </div>
        </div>

        <div
          class="mock_status"
          v-if="$store.getters.getMock"
          @click="mockSwitch"
        >
          <div class="status">
            <!-- <span class="ant-badge-status-dot ant-badge-status-success"></span> -->

            <span
              class="mb-0 ant-badge ant-badge-status ant-badge-not-a-wrapper"
              style="margin-top: 5px"
              >{{
              }}<span class="ant-badge-status-text mr-10"
                >กดเพื่อกลับสู่โหมดปกติ</span
              ></span
            >
          </div>
        </div>

        <div
          class="reset_wallet"
          v-if="$store.getters.getMock"
          @click="resetWallet"
        >
          <div class="status">
            <!-- <span class="ant-badge-status-dot ant-badge-status-success"></span> -->

            <span
              class="mb-0 ant-badge ant-badge-status ant-badge-not-a-wrapper"
              style="margin-top: 5px"
              >{{
              }}<span class="ant-badge-status-text mr-10"
                >กดเพื่อรีเซ็ตเงิน</span
              ></span
            >
          </div>
        </div>

        <!-- / Floating Action Button For Toggling Settings Drawer -->

        <!-- Sidebar Overlay -->
        <div
          class="sidebar-overlay"
          @click="sidebarCollapsed = true"
          v-show="!sidebarCollapsed"
        ></div>
        <!-- / Sidebar Overlay -->
      </a-layout>
      <!-- / Layout Content -->

      <!-- Settings Drawer -->
      <DashboardSettingsDrawer
        :showSettingsDrawer="showSettingsDrawer"
        :navbarFixed="navbarFixed"
        :sidebarTheme="sidebarTheme"
        :themeDarkMode="themeDarkMode"
        @toggleSettingsDrawer="toggleSettingsDrawer"
        @toggleNavbarPosition="toggleNavbarPosition"
        @updateSidebarTheme="updateSidebarTheme"
        @updateSidebarColor="updateSidebarColor"
        @toggleDark="toggleDark"
      ></DashboardSettingsDrawer>
      <!-- / Settings Drawer -->
    </a-layout>
    <!-- / Dashboard Layout -->
  </div>
</template>

<script>
import DashboardSidebar from "../components/Sidebars/DashboardSidebar";
import DashboardHeader from "../components/Headers/DashboardHeader";
import DashboardFooter from "../components/Footers/DashboardFooter";
import DashboardSettingsDrawer from "../components/Sidebars/DashboardSettingsDrawer";

export default {
  components: {
    DashboardSidebar,
    DashboardHeader,
    DashboardFooter,
    DashboardSettingsDrawer,
  },
  created() {
    this.themeDarkMode = true;

    if (localStorage.getItem("darkmode") !== null) {
      this.themeDarkMode =
        localStorage.getItem("darkmode").toLowerCase() === "true";
    }
  },
  data() {
    return {
      // Sidebar collapsed status.
      sidebarCollapsed: false,

      // Main sidebar color.
      sidebarColor: "primary",

      // Main sidebar theme : light, white, dark.
      sidebarTheme: "light",

      // Header fixed status.
      navbarFixed: false,

      // Settings drawer visiblility status.
      showSettingsDrawer: false,

      themeDarkMode: true,
    };
  },
  methods: {
    toggleSidebar(value) {
      this.sidebarCollapsed = value;
    },
    toggleDark(value) {
      this.themeDarkMode = value;
      localStorage.setItem("darkmode", this.themeDarkMode);
    },
    toggleSettingsDrawer(value) {
      this.showSettingsDrawer = value;
    },
    toggleNavbarPosition(value) {
      this.navbarFixed = value;
    },
    updateSidebarTheme(value) {
      this.sidebarTheme = value;
    },
    updateSidebarColor(value) {
      this.sidebarColor = value;
    },
    resetWallet() {
      this.$http
        .post(
          `${process.env.VUE_APP_BACKEND_API_URL}/api/me/mock/reset-balance`,
          {}
        )
        .then(({ data }) => {
          return data;
        })
        .catch((err) => {
          return;
        });
    },

    mockSwitch() {
      this.$http
        .post(`${process.env.VUE_APP_BACKEND_API_URL}/api/me/mock/switch`, {
          isMock: !this.$store.getters.getMock,
        })
        .then(({ data }) => {
          console.log(data, !this.$store.getters.getMock);
          this.$store
            .dispatch("setMock", !this.$store.getters.getMock)
            .then(() => {
              window.location.reload();
            });

          console.log(data);
        })
        .catch((err) => {
          return err;
        });
    },
  },
  computed: {
    // Sets layout's element's class based on route's meta data.
    layoutClass() {
      return this.$route.meta.layoutClass;
    },
  },
};
</script>
<style lang="scss">
.mock_border {
  position: fixed;
  border: #373737 solid 6px;

  z-index: 1;
}
.mock_nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100000000000000;
  text-align: center;

  .status {
    // border-radius: 0px 0px 4px 0px;

    background-color: #cc0001;
  }
}
.mock_status {
  position: fixed;
  top: 30px;
  left: 0px;
  height: 24px;
  z-index: 100;
  width: 150px;
  cursor: pointer;
  .status {
    border-radius: 0px 0px 4px 0px;

    background-color: #9f0000;
  }
}

.reset_wallet {
  position: fixed;
  top: 60px;
  left: 0px;
  height: 24px;
  width: 150px;
  z-index: 100;
  cursor: pointer;
  .status {
    border-radius: 0px 4px 4px 0px;

    background-color: rgb(255, 179, 0);
    border-color: rgb(194, 162, 0);
  }
}
</style>
